import { Button, Spin, Tabs } from "antd";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import LazyImg from "../components/Library/LazyImage";
import axiosInstance from "../config/axios-instance";
import bg_image from "../img/bg_library.jpg";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { history } from "../index";
import { useSelector } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";

const { TabPane } = Tabs;

export default function LibraryItem() {
  const { user, isAdmin } = useSelector((state: any) => state.auth);
  const { id }: any = useParams();

  const { isLoading, data }: any = useQuery(["fabric", id], () => fetchType());

  const fetchType = () => {
    let token = localStorage.getItem("token");
    return axiosInstance({
      method: "get",
      url: `/fabrics/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

  return (
    <div className="bookings-page">
      <header
        style={{
          backgroundImage: `url(${bg_image})`,
          height: 400,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        <Button
          style={{
            color: "#00468c",
            border: "1px solid #00468c",
            borderRadius: 5,
            position: "absolute",
            top: "22%",
          }}
          className="px-4 ml-5"
          icon={
            <FontAwesomeIcon
              icon={faArrowLeft}
              className="mr-2"
              style={{ color: "#00468c" }}
            />
          }
          onClick={() => history.back()}
        >
          Back
        </Button>
      </header>
      <div className="fabric-details-container">
        {isLoading ? (
          <div className="d-flex align-items-center justify-content-center">
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 100 }} spin />}
            />
          </div>
        ) : Object.keys(data.data).length === 0 ? (
          <h1 className="h1_huge text-center p-2">
            Something is wrong with this fabric
          </h1>
        ) : (
          <div
            className="fabric-details-wrapper p-3"
            style={{ marginTop: "-125px" }}
          >
            <div
              style={{ width: "fit-content" }}
              className="d-flex flex-column"
            >
              <Tabs defaultActiveKey="1" tabPosition="bottom">
                {data.data.images.map((img: any) => (
                  <TabPane
                    key={img.id}
                    tab={
                      <div className="tab-img">
                        <LazyImg
                          src={process.env.REACT_APP_STORAGE_URL + img.image}
                          style={{
                            width: "40px",
                            height: "40px",
                            border: "3px solid white",
                            objectFit: "cover",
                            borderRadius: "2px",
                          }}
                        />
                      </div>
                    }
                  >
                    <div className="image-view">
                      <LazyImg
                        key={img.id}
                        src={process.env.REACT_APP_STORAGE_URL + img.image}
                        style={{
                          width: "100%",
                          maxWidth: "300px",
                          height: "100%",
                          mexHeight: "300px",
                          border: "10px solid white",
                          objectFit: "cover",
                          borderRadius: "8px",
                        }}
                      />
                    </div>
                  </TabPane>
                ))}
              </Tabs>
              <p className="text-center fabric-item-name mt-2 mb-1">
                {data.data.name}
              </p>
            </div>
            <table className="fabric-details-table mb-3">
              {/* {data?.data.fabric_type && (
                <tr>
                  <th style={{ verticalAlign: "middle" }}>Fabric Type</th>
                  <td>{data?.data.fabric_type}</td>
                </tr>
              )} */}
              {data?.data.fabric && (
                <tr>
                  <th style={{ verticalAlign: "middle" }}>Fabric Type</th>
                  <td>{data?.data.fabric}</td>
                </tr>
              )}
              {((user && isAdmin) || data?.data.fabric_type === "knit") &&
                data?.data.supplier && (
                  <tr>
                    <th style={{ verticalAlign: "middle" }}>Supplier Name</th>
                    <td>{data?.data.supplier}</td>
                  </tr>
                )}
              {data?.data.color.name && (
                <tr>
                  <th style={{ verticalAlign: "middle" }}>Color</th>
                  <td>{data?.data.color.name}</td>
                </tr>
              )}
              {data?.data.composition_value && (
                <tr>
                  <th style={{ verticalAlign: "middle" }}>Composition</th>
                  <td style={{ verticalAlign: "middle" }}>
                    {data?.data.composition_value}
                  </td>
                </tr>
              )}
              {data && data.data.fabric_type === "denim" ? (
                <>
                  {data?.data.retrait_warp_max && (
                    <tr>
                      <th style={{ verticalAlign: "middle" }}>
                        Shrinkage Warp Max
                      </th>
                      <td style={{ verticalAlign: "middle" }}>
                        {data?.data.retrait_warp_max}
                      </td>
                    </tr>
                  )}
                  {data?.data.retrait_weft_max && (
                    <tr>
                      <th style={{ verticalAlign: "middle" }}>
                        Shrinkage Weft Max
                      </th>
                      <td style={{ verticalAlign: "middle" }}>
                        {data?.data.retrait_weft_max}
                      </td>
                    </tr>
                  )}
                  {data?.data.elasticity_min && (
                    <tr>
                      <th style={{ verticalAlign: "middle" }}>
                        Elasticity Min
                      </th>
                      <td>{data?.data.elasticity_min}</td>
                    </tr>
                  )}
                  {data?.data.growth && (
                    <tr>
                      <th style={{ verticalAlign: "middle" }}>Growth</th>
                      <td style={{ verticalAlign: "middle" }}>
                        {data?.data.growth}
                      </td>
                    </tr>
                  )}
                </>
              ) : (
                data?.data.weight_value && (
                  <tr>
                    <th style={{ verticalAlign: "middle" }}>Weight</th>
                    <td style={{ verticalAlign: "middle" }}>
                      {data?.data.weight_value}
                    </td>
                  </tr>
                )
              )}
            </table>
            {/* {data && data.data.fabric_type === "denim" && (
              <table className="fabric-details-table mb-3">
                <tr>
                  <th style={{ verticalAlign: "middle" }}>Fiber</th>
                  <td style={{ verticalAlign: "middle" }}>
                    {data?.data.fiber.name}
                  </td>
                </tr>
                <tr>
                  <th style={{ verticalAlign: "middle" }}>Retrait Wrap Max</th>
                  <td style={{ verticalAlign: "middle" }}>
                    {data?.data.retrait_wrap_max}
                  </td>
                </tr>
                <tr>
                  <th style={{ verticalAlign: "middle" }}>Retrait Weft Max</th>
                  <td style={{ verticalAlign: "middle" }}>
                    {data?.data.retrait_weft_max}
                  </td>
                </tr>
                <tr>
                  <th style={{ verticalAlign: "middle" }}>Growth</th>
                  <td style={{ verticalAlign: "middle" }}>
                    {data?.data.growth}
                  </td>
                </tr>{" "} */}
            {/* <tr>
                <th>Tearing Wrap Min</th>
                <td>{data?.data.tearing_wrap_min}</td>
              </tr>
              <tr>
                <th>Tearing Weft Min</th>
                <td>{data?.data.tearing_weft_min}</td>
              </tr>
              <tr>
                <th>Tearing Weft</th>
                <td>{data?.data.tearing_weft}</td>
              </tr>
              <tr>
                <th>Tearing Wrap</th>
                <td>{data?.data.tearing_wrap}</td>
              </tr>
              <tr>
                <th>Tearing Wrap Rate</th>
                <td>{data?.data.tearing_wrap_rate}</td>
              </tr> */}
            {/* {user && isAdmin && (
                <tr>
                  <th>Meters In Stock</th>
                  <td>{data?.data.meters_in_stock}</td>
                </tr>
              )} */}
            {/* </table>
            )} */}
          </div>
        )}
      </div>
    </div>
  );
}
